"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.contactsManagment")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.contactsManagment", {
            url: "/contatos",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-contacts-managment" */ "./contacts-managment.entry"
                ).then(() =>
                    Promise.all([
                        $ocLazyLoad.inject("nucont.accounting.contactsManagment"),
                        $ocLazyLoad.inject("nucont.accounting.overview")
                    ])
                );
            },
            views: {
                "admin@nucont.accounting": {
                    component: "contactsManagementComponent"
                }
            }
        })
        .state("nucont.accounting.contactsManagment.companies", {
            url: "/empresas?contact&editContact",
            params: {
                contact: { value: null, dynamic: true },
                editContact: { value: null, dynamic: true }
            },
            views: {
                "contactsManagmentView@nucont.accounting.contactsManagment": {
                    component: "companiesContactsViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "searchInput.placeholder",
                            value: "Procurar empresa"
                        }
                    ]
                }
            }
        })
        .state("nucont.accounting.contactsManagment.others", {
            url: "/outros?editContact",
            params: {
                editContact: { value: null, dynamic: true }
            },
            views: {
                "contactsManagmentView@nucont.accounting.contactsManagment": {
                    component: "othersContactsViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "searchInput.placeholder",
                            value: "Procurar empresa e grupo"
                        }
                    ]
                }
            }
        });
}
